import React from "react";
import { Plus, Quote, Trash2 } from "lucide-react";

import { Input } from "../../../components/ui/input";

import Bloco from "../../ofertas-do-dia/admin/regras/Bloco";

const MAXIMO = 12;

export default function SecaoExemplos({ exemplos, onMudar }) {
  const mudar = (i, texto) => onMudar(exemplos.map((e, j) => (j === i ? texto : e)));
  const remover = (i) => onMudar(exemplos.filter((_, j) => j !== i));
  return (
    <Bloco icone={Quote} titulo="Mensagens de inspiração" corIcone="bg-amber-500/15 text-amber-500"
      subtitulo="Exemplos do estilo que você gosta. A CLEO se inspira neles pra escrever — não copia. Se a IA ficar fora do ar, um deles vai pra quem pediu o cardápio.">
      <div className="space-y-2" data-e2e="exemplos-cleo">
        {exemplos.map((texto, i) => (
          <div key={i} className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground tabular-nums w-5 text-right shrink-0">{i + 1}</span>
            <Input value={texto} maxLength={300} onChange={(e) => mudar(i, e.target.value)} aria-label={`Exemplo ${i + 1}`} />
            <button type="button" onClick={() => remover(i)} disabled={exemplos.length <= 1}
              className="w-9 h-9 shrink-0 rounded-lg border flex items-center justify-center text-muted-foreground hover:text-red-500 hover:border-red-500/40 disabled:opacity-30"
              aria-label={`Remover exemplo ${i + 1}`}>
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
      {exemplos.length < MAXIMO && (
        <button type="button" onClick={() => onMudar([...exemplos, ""])}
          className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-600 dark:text-amber-400 hover:underline">
          <Plus className="w-4 h-4" /> Adicionar exemplo
        </button>
      )}
    </Bloco>
  );
}
